import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  OnChanges,
  Output
} from '@angular/core';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { getCurrentTab } from '@iv/store/tabs/tabs.selectors';
import Utils from '@iv/shared/utils';

@Component({
  selector: 'iv-live-columns-chooser',
  templateUrl: './columns-chooser.component.html',
  styleUrls: ['./columns-chooser.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnsChooserComponent implements OnInit, OnChanges {

  @Input() regionId: number;
  @Input() columns: any[];
  @Input() visibleColumns: string[];
  @Input() needRestoreDefaultColumns: boolean = false;

  @Output() restoreDefaultColumns = new EventEmitter<any>();
  @Output() columnSwitch = new EventEmitter<any>();
  @Output() saveDefault = new EventEmitter<any>();
  public isMac = Utils.isMac;
  uniqueColumns = [];
  saveDefaultDisabled = false;
  private _uniqueColumns = [];
  private _visibleColumns: string[];

  constructor(
    @Inject(AppStore) private store: Redux.Store<AppState>
  ) {
  }

  ngOnInit() {
    this._visibleColumns = this.visibleColumns.map(x => x);
    this._uniqueColumns = this.columns.map(x => Object.assign({}, x));
    this._sortColumns(this._uniqueColumns);
    this.filterColumns();
  }
  ngOnChanges() {
    this._visibleColumns = this.visibleColumns.map(x => x);
  }

  updateColumns() {
    this._visibleColumns = getCurrentTab(this.store.getState()).data.visibleColumns;
  }

  filterColumns(value?): void {
    this._filterColumns('uniqueColumns', value);
  }

  onApplyClick() {
    this.columnSwitch.emit(this._visibleColumns);
  }

  onSelectAllClick() {
    if (this.regionId === 1) {
      this._visibleColumns = this._uniqueColumns.map(column => column.dataField);
    } else {
      this._visibleColumns = this._uniqueColumns.filter(c => c.mode !== 'rt').map(column => column.dataField);
    }

    this.saveDefaultDisabled = false;
  }

  onUnselectAllClick() {
    this._visibleColumns = [];
    this.saveDefaultDisabled = false;
  }

  toggleColumn(dataField) {
    const index = this._visibleColumns.indexOf(dataField);
    if (index > -1) {
      this._visibleColumns.splice(index, 1);
    } else {
      this._visibleColumns.push(dataField);
    }
    this.saveDefaultDisabled = false;
  }

  isColumnVisible(column: string) {
    return this._visibleColumns.indexOf(column) > -1;
  }

  onSaveDefaultClick() {
    this.saveDefaultDisabled = true;
    this.saveDefault.emit(this._visibleColumns);
  }

  clearSearch(searchInput: HTMLInputElement) {
    searchInput.value = '';
    this.filterColumns('');
  }

  private _sortColumns(columns) {
    columns.sort(function (a, b) {
      if (a.caption.indexOf('HVP') > -1 && b.caption.indexOf('HVP') > -1) {
        return a.caption - b.caption;
      }
      if (a.caption > b.caption) {
        return 1;
      }
      if (a.caption < b.caption) {
        return -1;
      }
      return 0;
    });
  }

  private _filterColumns(type, value?) {
    this[type] = this['_' + type].filter(function (item) {
      if (value) {
        return (item.caption.toLowerCase().indexOf(value.toLowerCase(), 0) > -1);
      }
      return true;
    }, this);
  }
}

